// BarChart.js
import React, {useContext, useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import faker from "faker";
import { ManageApis } from "../../AppServices/ManageApi";
import moment from "moment";
import Loader from "../Loader/Loader";
import { globalContext } from "../../App";
import { convertToUTC } from "../../Common/Utils/Utils";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const BarChart = ({ dateRange }) => {
  const [barData, setBarData] = useState(null);
  const { setIsLoader } = useContext(globalContext);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "",
      },
    },
  };


  // useEffect(() => {
  //   if (dateRange && dateRange.length === 2) {
  //     fetchTableData();
  //   }
  // }, [dateRange]);

  const fetchTableData = async () => {
    setIsLoader(true);
    let sDate = convertToUTC(dateRange[0])
    let eDates = convertToUTC(dateRange[1])
    try {
      let path =
        global.getDashMonthly +
        (dateRange && dateRange.length === 2
          ? `?startDate=${sDate}&endDate=${eDates}`
          : "");
      let reqstBody = {};
      const response = await commonApiCall({ path, reqstBody, method: "get" });
      if (response.response_data.data) {
        setBarData((prev) => response.response_data.data);
        // console.log("bar", response.response_data.data);
      } else {
        // Handle error case if necessary
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  async function commonApiCall({ path, reqstBody, method = "post" }) {
    try {
      if(!path) return 
      const result = await ManageApis(method, path, reqstBody);
      // console.log("RESULT..................", result);
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  
  const extractDataForChart = (apiData) => {
    let labels = [];
    let paidByCashData = [];
    let paidByChequeData = [];
    let paidByUpi = [];
    for (const date in apiData) {
      if (apiData.hasOwnProperty(date)) {
        const dataForDate = apiData[date];
        const totalPaidByCash = dataForDate.reduce((acc, item) => {
          return acc + item.paymentDetails.reduce((sum, detail) => sum + (detail.paidByCash || 0), 0);
        }, 0);
        const totalPaidByCheque = dataForDate.reduce((acc, item) => {
          return acc + item.paymentDetails.reduce((sum, detail) => sum + (detail.paidByCheque || 0), 0);
        }, 0);
        const totalPaidByUpi = dataForDate.reduce((acc, item) => {
          return acc + item.paymentDetails.reduce((sum, detail) => sum + (detail.paidByUPI || 0), 0);
        }, 0);

        labels.push(date);
        paidByCashData.push(totalPaidByCash);
        paidByChequeData.push(totalPaidByCheque);
        paidByUpi.push(totalPaidByUpi);
      }
    }
    return { labels, paidByCashData, paidByChequeData, paidByUpi };
};
  const { labels, paidByCashData, paidByChequeData, paidByUpi } = barData
    ? extractDataForChart(barData)
    : { labels: [], paidByCashData: [], paidByChequeData: [],paidByUpi:[] };

  const data = {
    labels,
    datasets: [
      {
        label: "Cash",
        data: paidByCashData,
        backgroundColor: "#1D3B6D",
      },
      {
        label: "Cheque",
        data: paidByChequeData,
        backgroundColor: "rgba(141, 187, 48, 1)",
      },
      {
        label: "UPI",
        data: paidByUpi,
        backgroundColor: "#e74432",
      },
    ],
  };

  return <Bar options={options} data={data} />;
};

export default BarChart;
